const requests = {
    addToCart: async (product) => {
        return await fetch('/api/cart/add', {
            method: 'POST',
            body: JSON.stringify(product),
            headers: {
                'Content-Type': 'application/json'
            }
        }).then(async res => {
            return await res.json().then(data => {return data})
        })
    },
    clearCart: async (cart) => {
        return await fetch('/api/cart/clear', {
            method: 'POST',
            body: JSON.stringify({cart_id: cart}),
            headers: {
                'Content-Type': 'application/json'
            }
        }).then(async res => {
            return await res.json().then(data => {return data})
        })
    },
    getCartCount: async (cart) => {
        return await fetch('/api/cart/count', {
            method: 'POST',
            body: JSON.stringify({cart_id: cart}),
            headers: {
                'Content-Type': 'application/json'
            }
        }).then(async res => {
            return await res.json().then(data => {return data})
        })
    },
    getCartItems: async (cart) => {
        return await fetch('/api/cart/getItems', {
            method: 'POST',
            body: JSON.stringify({cart_id: cart}),
            headers: {
                'Content-Type': 'application/json'
            }
        }).then(async res => {
            return await res.json().then(data => {return data})
        })
        .catch(err => {return {}})
    },
    removeFromCart: async (cart, product_id, quantity) => {
        return await fetch('/api/cart/removeItem', {
            method: 'POST',
            body: JSON.stringify({cart_id: cart, product_id: product_id, quantity: quantity}),
            headers: {
                'Content-Type': 'application/json'
            }
        }).then(async res => {
            return await res.json().then(data => {return data})
        })
    },
    getOptions: async () => {
        return await fetch('/api/productsList/options', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        }).then(async res => {
            return await res.json().then(data => {return data})
        })
    },
    getDefaultFilters: async () => {
        return await fetch('/api/productsList/defaultFilters', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        }).then(async res => {
            return await res.json().then(data => {return data})
        })
    },
    getProducts: async (filters, page, limit, sort, search) => {
        return await fetch('/api/productsList/getProducts', {
            method: 'POST',
            body: JSON.stringify({filters: filters, page: page, limit: limit, sort: sort, search: search}),
            headers: {
                'Content-Type': 'application/json'
            }
        }).then(async res => {
            return await res.json().then(data => {return data})
        })
    },
    getProduct: async (id) => { 
        return await fetch('/api/product/getProduct', {
            method: 'POST',
            body: JSON.stringify({id: id}),
            headers: {
                'Content-Type': 'application/json'
            }
        }).then(async res => {
            return await res.json().then(data => {return data})
        })
    },
    getSimilarProducts: async (containerId, count) => { 
        return await fetch('/api/productsList/getSimilarProducts', {
            method: 'POST',
            body: JSON.stringify({containerId: containerId, count: count}),
            headers: {
                'Content-Type': 'application/json'
            }
        }).then(async res => {
            return await res.json().then(data => {return data})
        })
    },
    getCartPrice: async (cart) => {
        return await fetch('/api/cart/getCartPrice', {
            method: 'POST',
            body: JSON.stringify({cart_id: cart}),
            headers: {
                'Content-Type': 'application/json'
            }
        }).then(async res => {
            return await res.json().then(data => {return data})
        })
    },
    getBlogPost: async (url) => {
        return await fetch('/api/blog/getPost', {
            method: 'POST',
            body: JSON.stringify({blog_url: url}),
            headers: {
                'Content-Type': 'application/json'
            }
        }).then(async res => {
            return await res.json().then(data => {return data})
        })
    },
    getAllBlogPosts: async () => {
        return await fetch('/api/blog/getAllPosts', {
            method: 'POST',
        }).then(async res => {
            return await res.json().then(data => {return data})
        })
    },
}

export default requests;